'use client';

import { FileText } from 'lucide-react';
import { SectionHeader } from '../shared';

interface TextSectionProps {
  text: string | null | undefined;
  label?: string | null;
}

export function TextSection({ text, label }: TextSectionProps) {
  if (!text) {
    return null;
  }

  return (
    <div>
      <SectionHeader title={label || 'Description'} />
      <div className="p-2 rounded-lg bg-muted/30 border border-border">
        <p className="text-xs text-foreground whitespace-pre-wrap">
          {text}
        </p>
      </div>
    </div>
  );
}
